import { render } from "./UiSettingsRow.vue?vue&type=template&id=3ba823fa&ts=true"
import script from "./UiSettingsRow.vue?vue&type=script&lang=ts&setup=true"
export * from "./UiSettingsRow.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/UiSettingsRow.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3ba823fa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3ba823fa', __exports__)) {
    api.reload('3ba823fa', __exports__)
  }
  
  module.hot.accept("./UiSettingsRow.vue?vue&type=template&id=3ba823fa&ts=true", () => {
    api.rerender('3ba823fa', render)
  })

}


export default __exports__